import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import AddToolbar from "../../components/common/AddToolbar";
import Addradio from "../../components/setting/Addradio";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import { externalpostApi } from "../../services/external/externalApis";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import {
  COMPCODE,
  BUSINESSTYPECODE,
  LOCCODE,
  RESTCODE,
  SETTINGS_API_18,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";

const AddGiftVoucher = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const gotToView = () => {
    navigate("/vGiftVoucher");
  };
  const SYS_USER = useSelector((state) => state.user) || {};
  const { USERNAME } = SYS_USER.USER_PARAM || {};
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { selectedItem, CERTIFICATECODE } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    VOUCHERNO: "",
    BARCODE: "",
  });
  console.log("code", CERTIFICATECODE);
  useEffect(() => {
    if (selectedItem) {
      console.log("code", selectedItem.CERTIFICATECODE);
      setSelectedItemDetails({
        CERTIFICATECODE: String(selectedItem.CERTIFICATECODE),
        VOUCHERNO: String(selectedItem.VOUCHERNO),
        BARCODE: selectedItem.BARCODE,
      });
    }
  }, [selectedItem]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };

  const handleConfirmClick = async () => {
    const { VOUCHERNO, BARCODE } = selectedItemDetails;

    const requiredFields = [
      { name: "VOUCHERNO", value: VOUCHERNO, label: "Voucher No" },
      { name: "BARCODE", value: BARCODE, label: "Barcode" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }
    // Continue with the rest of your function logic...

    // if (data) {
    //   const isDuplicate = data.some((item) => {
    //       if((item.CERTIFICATECODE!= selectedItemDetails.CERTIFICATECODE)&& item.GIFTNAME === GIFTNAME){
    //         return true;
    //       }
    //       else {
    //         return false;
    //       }
    //   });
    //   if (isDuplicate) {
    //     setSnackbarMessage("  Gift Certificate Name already exists.");
    //     setOpenErrorSnackbar(true);
    //     return; // Stop the function if a duplicate is found
    //   }
    // }

    const staticValues = {
      CERTIFICATECODE: CERTIFICATECODE, // Ensure certificate code is handled
      giftvouchercode: "",
      STS: CON_STATUS_ACTIVE,
      Enuser: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_18, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        VOUCHERNO: "",

        BARCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      VOUCHERNO: "",

      BARCODE: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Gift Certificates</Link>
                <Link underline="hover">Add Gift Voucher</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={() => gotToView(5)}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar label={{ name: " Add Gift Voucher" }} />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Gift Certificate Code"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              value={CERTIFICATECODE || "N/A"} // Display CERTIFICATECODE or a default value
              InputProps={{
                readOnly: true, // Make it read-only since it's passed via location.state
              }}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Gift Voucher Number<span style={{ color: "red" }}> *</span>
                </span>
              }
              required
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="VOUCHERNO"
              value={selectedItemDetails.VOUCHERNO}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Gift Voucher Barcode <span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="BARCODE"
              value={selectedItemDetails.BARCODE}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            Confirm
          </Button>
        </Stack>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            Created Successfully!
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            Please fill out all fields before submitting.
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default AddGiftVoucher;
